import React from 'react';
import {
  ComposedChart, Line, ResponsiveContainer, Tooltip, XAxis, YAxis,
} from 'recharts';
import useMobileLayout from 'Hooks/useMobileLayout';
import useManagedAccountPageEventLogger
  from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/managedAccountPage.eventLogging';
import PerformanceLineDot from './PerformanceLineDot';
import useAccountPerformance from './useAccountPerformance';
import AccountPerformanceChartTooltip from './AccountPerformanceChartTooltip';
import {
  BENCHMARK_CHART_COLOR,
  BENCHMARK_CHART_NAME,
  PERFORMANCE_CHART_COLOR,
  PERFORMANCE_CHART_NAME,
} from './accountPerformance.consts';

export default function AccountPerformanceChart({ resource, showBenchmark }) {
  const isMobile = useMobileLayout();

  const {
    performanceData,
    benchmarkData,
    xAxisArgs,
    yAxisArgs,
  } = useAccountPerformance(resource);

  const { logPerformanceChartEvent } = useManagedAccountPageEventLogger();

  function handleXAxisClick() {
    logPerformanceChartEvent('Date Axis');
  }

  function handleYAxisClick() {
    logPerformanceChartEvent('Percentage Axis');
  }

  return <>
    <ResponsiveContainer height="100%" width="100%">
      <ComposedChart margin={{
        top: 0, right: 0, bottom: 0, left: 0,
      }}
      >
        {/* Date axis */}
        <XAxis
          dataKey={xAxisArgs.dataKey}
          type={xAxisArgs.type}
          domain={xAxisArgs.domain}
          scale={xAxisArgs.scale}
          ticks={xAxisArgs.ticks}
          tickFormatter={xAxisArgs.tickFormatter}
          allowDuplicatedCategory={false}
          padding={{ left: 20, right: 20 }}
          axisLine={{ stroke: '#EAF0F4' }}
          tickLine={false}
          onClick={handleXAxisClick}
        />

        {/* Value axis */}
        <YAxis
          width={isMobile ? 0 : 60}
          dataKey={yAxisArgs.dataKey}
          type={yAxisArgs.type}
          domain={yAxisArgs.domain}
          scale={yAxisArgs.scale}
          ticks={yAxisArgs.ticks}
          tickFormatter={yAxisArgs.tickFormatter}
          allowDuplicatedCategory={false}
          padding={{ top: 20, bottom: 20 }}
          interval="preserveStartEnd"
          minTickGap={10}
          axisLine={false}
          tickLine={false}
          onClick={handleYAxisClick}
        />

        {showBenchmark && (
          <Line
            dataKey="y"
            type="monotone"
            name={BENCHMARK_CHART_NAME}
            data={benchmarkData}
            dot={false}
            activeDot
            stroke={BENCHMARK_CHART_COLOR}
            strokeWidth={3}
          />
        )}

        <Line
          dataKey="y"
          type="monotone"
          name={PERFORMANCE_CHART_NAME}
          data={performanceData}
          dot={<PerformanceLineDot />}
          activeDot
          stroke={PERFORMANCE_CHART_COLOR}
          strokeWidth={3}
        />

        <Tooltip content={<AccountPerformanceChartTooltip showBenchmark={showBenchmark} />} wrapperStyle={{ outline: 'none' }} />
      </ComposedChart>
    </ResponsiveContainer>
  </>;
}
